var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-css",domProps:{"innerHTML":_vm._s(_vm.mData.noi_dung)}})
}
var staticRenderFns = []

export { render, staticRenderFns }